import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'presto-business-skin',
  styleUrl: 'presto-business-skin.scss',
  shadow: false,
})
export class PrestoBusinessSkin {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
